import { from, Observable } from "rxjs";
import { apiClient } from "./api";
import { ENDPOINTS } from "@/settings/api-settings";
import { map } from "rxjs/operators";
import { CrmCalendarioFiltrosDTO } from "@/interfaces/crm-calendar";
import { ConflitoAgendaFiltros } from "@/interfaces/calendar";

export function listCrmCalendarItems(filters: CrmCalendarioFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_CALENDAR, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmCalendarVisitorsCombo(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_CALENDAR_VISITORS_COMBO)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listCrmCalendarConflicts(parms: ConflitoAgendaFiltros): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_CALENDAR_CONFLICTS, parms)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}